/**
 * Display string for report "Актуальность отчёта" (OperationReport / ReportConstructor).
 */
function formatReportFreshness(processedAt: string | null | undefined): string {
  if (!processedAt || processedAt === '1970-01-01 00:00:00.000000') {
    return 'нет данных';
  }
  const utcDate = new Date(`${String(processedAt).replace(' ', 'T')}Z`);
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const pad = (n: number) => String(n).padStart(2, '0');
  const localStr = `${pad(utcDate.getHours())}:${pad(utcDate.getMinutes())}:${pad(utcDate.getSeconds())} `
    + `${pad(utcDate.getDate())}.${pad(utcDate.getMonth() + 1)}.${utcDate.getFullYear()}`;

  const diffMs = Date.now() - utcDate.getTime();
  const totalSec = Math.max(0, Math.floor(diffMs / 1000));
  const hours = Math.floor(totalSec / 3600);
  const minutes = Math.floor((totalSec % 3600) / 60);
  const seconds = totalSec % 60;
  const parts: string[] = [];
  if (hours > 0) parts.push(`${hours} ч`);
  if (minutes > 0) parts.push(`${minutes} мин`);
  if (seconds > 0 || parts.length === 0) parts.push(`${seconds} сек`);
  const ago = `${parts.join(' ')} назад`;

  return `${localStr} (${tz}) (${ago})`;
}

export default formatReportFreshness;
